export const appsEngagementReportsTags = "/apps/engagement_reports/tags";
